<app-modal #modal>

  <span title>{{"Documents"|translate}}</span>

  <div class="list-group" body>
    <!-- @if(!loaderService.loading()){ -->
    @if(attachmentList().length > 0){
    @for (attachment of attachmentList(); track $index) {
    <a class="list-group-item list-group-item-action"
      (click)="sharedService.navigateTo_PdfPage(attachment.url)">
      <!-- (click)="productsService.downloadFromUrl(attachment.url, '')"> -->
      <span>{{attachment.name}}</span>
      <i class="bi bi-chevron-right"></i>
    </a>
    }
    }@else{
    <div class="placeholder-wrapper">
      <app-placeholder [message]="'There are no Attachments'|translate"></app-placeholder>
    </div>
    }
    <!-- } -->
  </div>

  <div footer class="footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      {{"Close"|translate}}
    </button>
  </div>

</app-modal>
